import { AemDynamicMediaParams } from '@abg/typings/aem/types';

export const getAemImageUrl = (
  source: string,
  params: AemDynamicMediaParams,
) => {
  const { smartCropName, fitUpscale, fit, bfc = 'on', ...rest } = params;

  // Embed Smart Crop for Dynamic Media to preserve image focal point
  const imagePath = smartCropName ? `${source}:${smartCropName}` : source;

  const queryParams: string[] = [];

  for (const [key, value] of Object.entries({ ...rest, bfc })) {
    if (value != null) {
      queryParams.push(`${key}=${value.toString()}`);
    }
  }

  if (fit) {
    const fitValue = `${fit},${fitUpscale ? 1 : 0}`;
    queryParams.push(`fit=${fitValue}`);
  }

  // Construct and return the final URL
  return queryParams.length > 0
    ? `${imagePath}?${queryParams.join('&')}`
    : imagePath;
};
